import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "language-switch-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    color: "primary",
    height: "56",
    class: "z-10"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "logo",
        src: _ctx.logo
      }, null, 8, _hoisted_1),
      _createVNode(_component_v_app_bar_title, { class: "zamg-text-headline ml-8" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('toolbar.header')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "language-switch-vertical-bar" }, null, -1)),
        _createVNode(_component_v_select, {
          modelValue: _ctx.currentLanguage,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentLanguage) = $event)),
            _cache[1] || (_cache[1] = (value) => _ctx.switchToLanguage(value))
          ],
          items: _ctx.languages,
          "item-title": "label",
          "item-value": "code",
          density: "compact",
          class: "language-switch",
          "hide-selected": "",
          "hide-details": "",
          "icon-color": _ctx.iconColor,
          "menu-icon": "mdi-chevron-down",
          "bg-color": "primary",
          "max-width": "5rem",
          variant: "text",
          "data-testid": "language-switch"
        }, {
          item: _withCtx(({props}) => [
            _createVNode(_component_v_list, {
              density: "compact",
              class: "language-switch-list"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, _mergeProps(props, {
                  density: "compact",
                  class: "language-switch-list-item"
                }), null, 16)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["modelValue", "items", "icon-color"])
      ])
    ]),
    _: 1
  }))
}